export default __webpack_public_path__ + "static/104-min-min-edefe485ea296bb0b1e2bf513471cc01.jpg";